// extracted by mini-css-extract-plugin
export default {"attachment":"attachment--22214530","add":"add--0ce66725","thumb":"thumb--d70a23be","file":"file--5fdbdfa7","pdf":"pdf--7d7cad2d","close":"close--d52a9df3"};